enum StorageBucket {
    CoreContent = "core-content",
    UserContent = "user-content"
}

export default StorageBucket;